import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import refetchPricesOperation from 'store/price/operation/refetchPricesOperations';

const PLUS_DISCOUNT_APPLIED = 'plusdiscountapplied';
const PLUS_DISCOUNT_ACTIVE = 'plusdiscountactive';

const usePlusDiscount = () => {
  const [isPlusDiscountActive, setPlusDiscountActive] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const handlePlusDiscountActive = (e: Event) => {
      setPlusDiscountActive((e as CustomEvent).detail);
    };

    const handlePlusDiscountApplied = () => {
      setPlusDiscountActive(true);
      dispatch(refetchPricesOperation());
    };

    window.addEventListener(PLUS_DISCOUNT_ACTIVE, handlePlusDiscountActive);
    window.addEventListener(PLUS_DISCOUNT_APPLIED, handlePlusDiscountApplied);

    return () => {
      window.removeEventListener(PLUS_DISCOUNT_ACTIVE, handlePlusDiscountActive);
      window.removeEventListener(PLUS_DISCOUNT_APPLIED, handlePlusDiscountApplied);
    };
  }, []);

  return { isPlusDiscountActive };
};

export default usePlusDiscount;
